import { type ReactElement } from 'react';
import { Chip } from '@citibox-panel/ui';
import type { QrBatchStatus } from '../lib/qrBatch';

// TODO: i18n — copy en ES hasta Fase 1.
const LABELS: Record<QrBatchStatus, { label: string; color: 'info' | 'success' | 'error' }> = {
  PENDING: { label: 'Generando', color: 'info' },
  DONE: { label: 'Listo', color: 'success' },
  FAILED: { label: 'Error', color: 'error' },
};

// The colour repeats what the word says; the word carries the meaning.
export function BatchStatusChip({ status }: { status: QrBatchStatus }): ReactElement {
  const { label, color } = LABELS[status];
  return <Chip label={label} color={color} size="small" />;
}
